// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1au7A","footer":"styles_footer__1p-du"};